export default __webpack_public_path__ + "static/media/comment-sound.21ada807.wav";